<div *ngIf="!loading && count === 0">
  <p class="text-center m-2">{{message}}</p>
</div>
